import { NgFor, NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-termsandcondition',
  standalone: true,
  imports: [NgFor, NgTemplateOutlet],
  templateUrl: './termsandcondition.component.html',
  styleUrl: './termsandcondition.component.scss'
})
export class TermsandconditionComponent {
  tocItems = [
    { id: 'services', title: 'OUR SERVICES' },
    { id: 'intellectual-property-rights', title: 'INTELLECTUAL PROPERTY RIGHTS' },
    { id: 'user-representations', title: 'USER REPRESENTATIONS' },
    { id: 'user-registration', title: 'USER REGISTRATION' },
    { id: 'products', title: 'PRODUCTS' },
    { id: 'purchases-and-payment', title: 'PURCHASES AND PAYMENT' },
    { id: 'subscriptions', title: 'SUBSCRIPTIONS' },
    { id: 'return-refunds-policy', title: 'RETURN/REFUNDS POLICY' },
    { id: 'prohibited-activities', title: 'PROHIBITED ACTIVITIES' },
    { id: 'user-generated-contributions', title: 'USER GENERATED CONTRIBUTIONS' },
    { id: 'contribution-license', title: 'CONTRIBUTION LICENSE' },
    { id: 'guidelines-for-reviews', title: 'GUIDELINES FOR REVIEWS' },
    { id: 'mobile-application-license', title: 'MOBILE APPLICATION LICENSE' },
    { id: 'services-management', title: 'SERVICES MANAGEMENT' },
    { id: 'privacy-policy', title: 'PRIVACY POLICY' },
    { id: 'copyright-infringements', title: 'COPYRIGHT INFRINGEMENTS' },
    { id: 'term-and-termination', title: 'TERM AND TERMINATION' },
    { id: 'modifications-and-interruptions', title: 'MODIFICATIONS AND INTERRUPTIONS' },
    { id: 'governing-law', title: 'GOVERNING LAW' },
    { id: 'dispute-resolution', title: 'DISPUTE RESOLUTION' },
    { id: 'corrections', title: 'CORRECTIONS' },
    { id: 'disclaimer', title: 'DISCLAIMER' },
    { id: 'limitations-of-liability', title: 'LIMITATIONS OF LIABILITY' },
    { id: 'indemnification', title: 'INDEMNIFICATION' },
    { id: 'user-data', title: 'USER DATA' },
    { id: 'electronic-communications', title: 'ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES' },
    { id: 'california-users', title: 'CALIFORNIA USERS AND RESIDENTS' },
    { id: 'miscellaneous', title: 'MISCELLANEOUS' },
    // { id: 'consent-to-messaging', title: 'Consent to Messaging' },
    // { id: 'opt-out-instructions', title: 'Opt-Out Instructions' },
    // { id: 'message-Frequency-Content', title: 'Message Frequency and Content' },
    // { id: 'liability-disclaimers', title: 'Liability and Disclaimers' },
    { id: 'contact-us', title: 'CONTACT US' }
  ];
  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
